import dayjs from "dayjs"
import { TypeFlight, TypeIntermediateStop, TypeSegment } from "@/lib/redux/features/flight/type"

/**
 * Lấy danh sách transit ẩn (intermediate_stops) cần hiển thị dưới 1 segment cụ thể.
 * intermediate_stops nằm ở cấp flight (theo DOP-881) - callback đã bơm từ e4t vào flight.
 * - Flight 1 segment: mọi stop thuộc segment đó.
 * - Flight nhiều segment: gán mỗi stop vào segment có khung giờ chứa nó; nếu không khớp
 *   (thường do lệch timezone giữa dữ liệu stop & segment) thì fallback về segment đầu tiên,
 *   đảm bảo mỗi stop luôn hiển thị đúng 1 lần, không nhân đôi.
 */
export const getSegmentIntermediateStops = (
  flight?: TypeFlight | null,
  segment?: (TypeSegment & { intermediate_stops?: TypeIntermediateStop[] }) | null
): TypeIntermediateStop[] => {
  const segs = flight?.segments || []
  if (!segment || !segs.length) return []

  const stops: TypeIntermediateStop[] = segment.intermediate_stops?.length
    ? segment.intermediate_stops
    : (flight?.intermediate_stops || [])
  if (!stops.length) return []

  if (segs.length === 1) return stops

  const segIndex = segs.findIndex(s =>
    s.startPoint === segment.startPoint &&
    s.endPoint === segment.endPoint &&
    s.startTime === segment.startTime
  )
  if (segIndex < 0) return []

  return stops.filter(stop => {
    const arr = dayjs(`${stop.arrival_date}T${stop.arrival_time}`)
    let idx = 0 // fallback: chặng đầu
    if (arr.isValid()) {
      const found = segs.findIndex(s => {
        const st = dayjs(s.startTime), en = dayjs(s.endTime)
        return st.isValid() && en.isValid() && !arr.isBefore(st) && !arr.isAfter(en)
      })
      if (found >= 0) idx = found
    }
    return idx === segIndex
  })
}

/** Format phút (dạng string "120") -> { hours, mins } để hiển thị "2h 0m". */
export const parseStopDuration = (duration?: string) => {
  const total = parseInt(duration || "0", 10) || 0
  return { hours: Math.floor(total / 60), mins: total % 60 }
}
